export class DepositPixModel {
  endToEndId: string = '';
}
